var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.397,
    height: 16.397,
    viewBox: "0 0 16.397 16.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dashboard-line",
    d: "M12.11,19.4v-9.11H19.4V19.4ZM3,12.11V3h7.288v9.11Zm5.466-1.822V4.822H4.822v5.466ZM3,19.4V13.932h7.288V19.4Zm1.822-1.822H8.466V15.754H4.822Zm9.11,0h3.644V12.11H13.932ZM12.11,3H19.4V8.466H12.11Zm1.822,1.822V6.644h3.644V4.822Z",
    transform: "translate(-3 -3)",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.cf086501d3f0c39581672725fc40a2e8.svg";
export { ForwardRef as ReactComponent };